<template>
  <div>
    <section class="bg-white">
      <div class="container w-full lg:w-3/4">
        <div>
          <h1 class="mb-3 text-left">{{ $t("alex.myPath") }}</h1>
          <p class="section--p text-base m-0">
            {{ $t("alex.myPathDesc") }}
          </p>
        </div>
        <div class="step" :class="autoLoginToken ? 'status-1' : 'status-0'">
          <div>
            <div class="line"></div>
          </div>
        </div>
        <div class="step" :class="activateFeedback ? 'status-1' : 'status-0'">
          <div class="flex">
            <div class="line step-1"></div>
            <CheckpointCircle :active="autoLoginToken" />
          </div>
          <div class="flex flex-wrap w-full margin-fix">
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="autoLoginToken"
                :currentPath="$options.PATH_NAMES.PROFILE"
                @rightArrowClicked="
                  $router.push(`/dpd-belux/editor/about`)
                "
              />
            </div>
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="autoLoginToken"
                :currentPath="$options.PATH_NAMES.ASSESSMENT"
                @rightArrowClicked="$router.push(`/${organizationSlug}/alex/assessment`)"
              />
            </div>
          </div>
        </div>
        <div class="step" :class="activateCompetency ? 'status-1' : 'status-0'">
          <div class="flex">
            <div class="line"></div>
            <CheckpointCircle :active="activateFeedback" />
          </div>
          <div class="flex flex-wrap w-full margin-fix">
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="activateFeedback"
                :currentPath="$options.PATH_NAMES.FEEDBACK"
                @rightArrowClicked="$router.push(`/${organizationSlug}/alex/feedback`)"
              />
            </div>
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="activateCompetency"
                :currentPath="$options.PATH_NAMES.COMPETENCIES"
                @rightArrowClicked="showCompetencyReport = true"
              />
            </div>
          </div>
        </div>
        <div class="step" :class="activateCompetency ? 'status-1' : 'status-0'">
          <div class="flex">
            <div class="line"></div>
            <CheckpointCircle :active="activateCompetency" />
          </div>
          <div>
            <div>
              <vx-card
                noShadow
                :class="activateCompetency ? 'alex-preferences' : 'inactive'"
              >
                <div class="flex flex-wrap items-center justify-between">
                  <div
                    class="flex flex-wrap items-start justify-center text-left w-full md:w-5/6"
                  >
                    <div class="px-4 flex justify-center mr-3">
                      <img
                        v-if="activateCompetency"
                        src="../../../../../assets/images/demo/alex-book-closed.png"
                        width="100px"
                        height="auto"
                        class="cursor-pointer"
                        @click="showChatPopup"
                      />
                      <img
                        v-else
                        src="../../../../../assets/images/demo/alex-book-closed-3.png"
                        width="100px"
                        height="auto"
                        :class="activateCompetency ? 'status-1' : 'status-0'"
                        @click="showChatPopup"
                      />
                    </div>
                    <div class="md:w-3/4 lg:w-4/5">
                      <p class="s-head">
                        {{
                          $t(
                            `alex.pathNames.${$options.PATH_NAMES.PREFERENCES}.shortDescription`
                          )
                        }}
                      </p>
                      <h5 class="mb-2 font-bold">
                        {{
                          $t(
                            `alex.pathNames.${$options.PATH_NAMES.PREFERENCES}.heading`
                          )
                        }}
                      </h5>
                      <p>
                        {{
                          $t(
                            `alex.pathNames.${$options.PATH_NAMES.PREFERENCES}.longDescription`,
                            {
                              orgName: organizationName,
                            }
                          )
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="w-full md:w-1/6 flex justify-end">
                    <img
                      v-if="activateCompetency"
                      src="../../../../../assets/images/icons/alex/arrow_right_orange.svg"
                      width="45px"
                      height="auto"
                      class="cursor-pointer"
                      @click="showChatPopup"
                    />
                    <img
                      v-else
                      src="../../../../../assets/images/icons/alex/arrow_right_grey.svg"
                      width="45px"
                      height="auto"
                    />
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <div class="step items-start" :class="activateCompetency ? 'status-1' : 'status-1'">
          <div class="flex">
            <div class="line"></div>
            <CheckpointCircle :active="activateCompetency ? true : false" />
          </div>
          <Library class="w-full" />
        </div>
        <div class="step items-start status-0" style="margin-bottom: 0">
          <div class="flex">
            <div class="line"></div>
            <CheckpointCircle :active="true" />
          </div>
          <div class="flex flex-wrap margin-fix items-strech w-full">
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="true"
                :currentPath="$options.PATH_NAMES.SITUATIONS"
                @rightArrowClicked="showSituation = true"
              />
            </div>
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="true"
                :currentPath="$options.PATH_NAMES.JOURNEY"
                @rightArrowClicked="showPlan= true"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <vs-popup
      fullscreen
      :title="$t('alex.competencyReportModalTitle')"
      :active.sync="showCompetencyReport"
    >
      <div style="height: 600px;">
        <iframe
          :src="`https://dpd.talentprint.com/profiles/`+autoLoginToken"
          class="w-full h-full border-0"
        >
        </iframe>
      </div>
    </vs-popup>
    <vs-popup
      fullscreen
      title="Situation"
      :active.sync="showSituation"
    >
      <div  style="height: 600px;">
        <iframe
          :src="`https://dpd.talentprint.com/situations/dash`+autoLoginToken"

          class="w-full h-full border-0"
        >
        </iframe>
      </div>
    </vs-popup>
    <vs-popup
      fullscreen
      title="Plan"
      :active.sync="showPlan"
    >
      <div  style="height: 600px;">
        <iframe
          :src="`https://dpd.talentprint.com/planners/dash`+autoLoginToken"

          class="w-full h-full border-0"
        >
        </iframe>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Library from "./Library";
import { PATH_NAMES, MY_PATH } from "@/assets/data/alex";
import MyPathCard from "./MyPathCard";
import CheckpointCircle from "./CheckpointCircle";
export default {
  components: {
    Library,
    MyPathCard,
    CheckpointCircle,
  },
  PATH_NAMES,
  MY_PATH,
  data() {
    return {
      showCompetencyReport: false,
      showSituation:false,
      showPlan:false
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    autoLoginToken() {
      console.log('autoLoginToken',this.$store.state.alex.data.youlabToken);
      return "?tk=MhCI9rtezBuDDW88";
    },
    userProgress() {
      return 2;
    },
    activateFeedback() {
      return  1;
    },
    activateCompetency() {
      return  2;
    },
    activatePreferences() {
      return  2;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    }
  },
  methods: {
    showChatPopup() {
      this.$store.commit("alex/SET_CHAT_ID", "a8g2DkK6");
      this.$store.commit("alex/TOGGLE_ALEX_CHAT_MODAL", true);
    },
  },
};
</script>
<style scoped>
p {
  line-height: unset;
  font-size: unset;
}
h5 {
  font-weight: bold;
}
h1 {
  color: #231d4f;
  font-weight: 400;
}
.alex-preferences {
  background: rgba(242, 147, 0, 0.1);
}
section {
  padding-top: 8rem;
}

.alex-preferences p,
.alex-preferences h5 {
  color: #f29300;
}

.s-head {
  margin-bottom: 0.2rem;
}

.active p.s-head {
  color: #f29300;
}
.step-headline.active,
.active h5 {
  color: #231d4f;
}
.active p {
  color: #848199;
}
.inactive h5,
.inactive p {
  color: #ccc !important;
}
.step-headline.inactive {
  color: #ccc !important;
}
.step {
  position: relative;
  display: flex;
}

.step:not(:last-child) {
  padding-bottom: 6rem;
}
.step:last-child {
  padding-bottom: 12rem;
}
.step > div:first-child img {
  z-index: 1;
  background: #fff;
  border-radius: 50%;
}
.line {
  position: absolute;
  left: 25px;
  top: 0px;
  bottom: 0px;
}
.line:only-child {
  top: 30px;
  bottom: 4px;
}
.step-1 {
  bottom: 4px;
}
.step.status-0 > div:first-child >>> .line {
  border-left: 2px dashed #d0cfcf;
}
.step.status-1 > div:first-child >>> .line {
  border-left: 2px dashed #f29300;
}
.step > div:first-child {
  margin-right: 2%;
}

.margin-fix {
  margin: -3rem -0.75rem 0 -0.75rem;
}

@media screen and (max-width: 500px) {
  .margin-fix {
    margin: -0.75rem;
  }
  .step > div:first-child img {
    height: 40px;
    width: 40px;
  }
  .line {
    left: 19px;
  }
}
</style>
